export const ADMINISTRATOR = 'Administrator';
export const USER = 'User';
export const STAKEHOLDER = 'Stakeholder';
export const POWER_USER = 'Power User';
export const CUSTOMER_PORTAL = 'Student';
export const USER_CUSTOMER_SERVICE = 'User (Customer Service)';
